// extracted by mini-css-extract-plugin
export default {"yearbookTitle":"YearbookEntry_yearbookTitle__5U9RL","yearbookItem":"YearbookEntry_yearbookItem__Fkvqb"};